/* eslint-disable max-len */
import React from 'react'

export const GoogleIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='29'
      viewBox='0 0 28 29'
      fill='none'
    >
      <path
        d='M26.2512 14.772C26.2512 13.7648 26.1678 13.0298 25.9873 12.2676H14.2512V16.8136H21.14C21.0012 17.9434 20.2512 19.6448 18.5845 20.7881L18.5612 20.9403L22.2719 23.7574L22.529 23.7826C24.89 21.6456 26.2512 18.5014 26.2512 14.772Z'
        fill='#4285F4'
      />
      <path
        d='M14.2505 26.7502C17.6254 26.7502 20.4587 25.6612 22.5282 23.7829L18.5837 20.7884C17.5282 21.5098 16.1115 22.0134 14.2505 22.0134C10.9449 22.0134 8.13941 19.8765 7.13932 16.9229L6.99273 16.9351L3.13426 19.8615L3.0838 19.9989C5.13933 24.0006 9.36154 26.7502 14.2505 26.7502Z'
        fill='#34A853'
      />
      <path
        d='M7.14005 16.9227C6.87617 16.1605 6.72345 15.3438 6.72345 14.4999C6.72345 13.656 6.87617 12.8394 7.12617 12.0771L7.11918 11.9148L3.21235 8.94141L3.08452 9.00099C2.23734 10.6616 1.75122 12.5263 1.75122 14.4999C1.75122 16.4735 2.23734 18.3382 3.08452 19.9988L7.14005 16.9227Z'
        fill='#FBBC05'
      />
      <path
        d='M14.2505 6.98663C16.5977 6.98663 18.181 7.98024 19.0838 8.81057L22.6116 5.435C20.445 3.46139 17.6255 2.25 14.2505 2.25C9.36158 2.25 5.13934 4.99942 3.0838 9.00106L7.12546 12.0772C8.13944 9.1236 10.945 6.98663 14.2505 6.98663Z'
        fill='#EB4335'
      />
    </svg>
  )
}
